import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupIntersect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"boolean-group-intersect"} maskId="square-filled-radius-0-stroke-1-IconBooleanGroupIntersect"><path fillRule="evenodd" clipRule="evenodd" d="M8 2H22V16H16V22H2V8H8V2ZM21 15H16V8H9V3H21V15ZM8 9H3V21H15V16H8V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBooleanGroupIntersect;
